<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-08 22:05:48
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-02 17:34:08
-->
<template>
	<!-- 修改备注 -->
	<el-dialog width="400px" title="编辑备注" :visible.sync="visible" :append-to-body="true" :before-close="beforeClose" :close-on-click-modal="false">
		<el-input v-model="remarks" autocomplete="off" :autosize="{ minRows: 4 }" type="textarea" maxlength="200" show-word-limit></el-input>
		<div slot="footer" class="dialog-footer">
			<el-button @click="beforeClose">取 消</el-button>
			<el-button type="primary" @click="confirm">确 认</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { setShopInfoRemark } from '@/api/cooperativeShop';
export default {
	name: 'remarkDialog',
	data() {
		return {
			visible: false,
			remarks: '',
			outerShopId: ''
		};
	},
	components: {},
	methods: {
		//备注弹框
		show(val = '', outerShopId) {
			this.outerShopId = outerShopId
			this.remarks = val;
			this.visible = true;
		},
		//提交备注
		async confirm() {
			const {outerShopId, remarks} = this
			await setShopInfoRemark({remarks, outerShopId})
			this.$message.success('编辑成功！');
			this.$emit('refresh');
			this.beforeClose();
		},
		beforeClose() {
			this.remarks = '';
			this.outerShopId = '';
			this.visible = false;
		},
	},
};
</script>
<style scoped></style>
